import { useEffect, useContext, useState } from 'react';
import { Button, Modal, Select } from 'semantic-ui-react';
import { store } from '../store';
import { SET_SHOW_SAVE_MODAL } from '../types';
import saveToLocalStorage from '../utils/saveToLocalStorage';

const SaveModal = () => {
  const { showSaveModal, referenceColors, dispatch } = useContext(store);
  const [name, setName] = useState('');
  const [paletteNames, setPaletteNames] = useState([]);

  useEffect(() => {
    const appData = JSON.parse(localStorage.getItem('photoReference'));
    if (appData) {
      const paletteNamesFromStorage = Object.keys(appData).map((palette) => ({
        value: palette,
        text: palette,
        key: palette,
      }));
      setPaletteNames(paletteNamesFromStorage);
    }
  }, []);

  const handlePaletteChange = (e, selectedPalette) =>
    setName(selectedPalette.value);

  const handleAddition = (e, { value }) => {
    const newPalette = {
      value,
      text: value,
      key: value,
    };
    setName(value);
    setPaletteNames((palettes) => [...palettes, newPalette]);
  };

  const close = () => dispatch({ type: SET_SHOW_SAVE_MODAL, payload: false });

  const save = () => {
    const appData = { name, data: referenceColors };
    saveToLocalStorage(appData);
    close();
  };

  return (
    <Modal size="mini" open={showSaveModal} onClose={close}>
      <Modal.Header>Save Color Palette</Modal.Header>
      <Modal.Content>
        <p>What is the name of your painting/palette?</p>
        <Select
          options={paletteNames}
          placeholder="Palette Name"
          search
          fluid
          allowAdditions
          value={name}
          onAddItem={handleAddition}
          onChange={handlePaletteChange}
        />
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={close}>Cancel</Button>
        <Button positive disabled={!name} onClick={save}>
          Save
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default SaveModal;
